import api from 'api'
import { WORK_ORDER_CACHE_INVALIDATION_TAGS, withDelayedWorkOrderInvalidation } from 'api/cacheInvalidationTagSets'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    postBillingAccountApplyCredit: build.mutation({
      query: body => ({ url: '/api/v1/billing/account/receivables/apply-credit', method: 'POST', body }),
      invalidatesTags: [...WORK_ORDER_CACHE_INVALIDATION_TAGS],
      onQueryStarted: withDelayedWorkOrderInvalidation({ api }),
    }),
  }),
})

export const { usePostBillingAccountApplyCreditMutation } = extendedApi
